import NoAccessContainer from "@containers/NoAccessContainer";

const NoAccessPage = () => {
  return <NoAccessContainer />;
};

export default NoAccessPage;
